module.exports = __webpack_public_path__ + "static/img/23-marketing.f3c43aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-marketing.png
// module id = kZP/
// module chunks = 1